import { slicedToArray as _slicedToArray, asyncToGenerator as _asyncToGenerator, regeneratorRuntime as _regeneratorRuntime } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import _styled from '@emotion/styled/base';
import React__default, { useState } from 'react';
import { useForm, FormProvider } from 'react-hook-form';
import { TextInputField, Button, Modal } from '@bucketplace/commerce-admin-ui';
import { useSnackbar } from '@bucketplace/design-system';
import { jsx } from '@emotion/react';
import '../../../contexts/internal/StickyContext.js';
import '../../../contexts/internal/EditorContext.js';
import { useStoreItemsContext } from '../../../contexts/external/StoreItemsContext.js';
import { covertStringToArray } from '../../../utils/format.js';
import { validateStringNumber } from '../../../utils/validation.js';
import 'qs';
import 'query-string';

function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
function ItemAddModal(_ref) {
  var _getFieldState;
  var ids = _ref.ids,
    onAddItems = _ref.onAddItems;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    showModal = _useState2[0],
    setShowModal = _useState2[1];
  var form = useForm({
    defaultValues: {
      itemIds: ''
    },
    mode: 'onBlur'
  });
  var getValues = form.getValues,
    getFieldState = form.getFieldState,
    setValue = form.setValue,
    setError = form.setError,
    clearErrors = form.clearErrors,
    handleSubmit = form.handleSubmit;
  var errorMessage = (_getFieldState = getFieldState('itemIds')) === null || _getFieldState === void 0 || (_getFieldState = _getFieldState.error) === null || _getFieldState === void 0 ? void 0 : _getFieldState.message;
  var _useStoreItemsContext = useStoreItemsContext(),
    getStoreItems = _useStoreItemsContext.getStoreItems;
  var _useSnackbar = useSnackbar(),
    open = _useSnackbar.open;
  var closeModal = function closeModal() {
    setShowModal(false);
    setValue('itemIds', '');
    clearErrors('itemIds');
  };
  var handleClickAdd = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      var _yield$getStoreItems;
      var formattedIds, deduplicatedIds, storeItems, existIds, failedIds;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            formattedIds = covertStringToArray(getValues('itemIds'));
            deduplicatedIds = Array.from(new Set(formattedIds));
            _context.next = 4;
            return getStoreItems === null || getStoreItems === void 0 ? void 0 : getStoreItems(deduplicatedIds);
          case 4:
            _context.t1 = _yield$getStoreItems = _context.sent;
            _context.t0 = _context.t1 !== null;
            if (!_context.t0) {
              _context.next = 8;
              break;
            }
            _context.t0 = _yield$getStoreItems !== void 0;
          case 8:
            if (!_context.t0) {
              _context.next = 12;
              break;
            }
            _context.t2 = _yield$getStoreItems;
            _context.next = 13;
            break;
          case 12:
            _context.t2 = [];
          case 13:
            storeItems = _context.t2;
            existIds = deduplicatedIds.filter(function (newId) {
              return ids.some(function (id) {
                return id === newId;
              });
            });
            failedIds = deduplicatedIds.filter(function (id) {
              return !storeItems.some(function (item) {
                return item.id.toString() === id;
              });
            });
            if (failedIds.length > 0) {
              setError('itemIds', {
                message: "".concat(failedIds === null || failedIds === void 0 ? void 0 : failedIds.join(', '), " \uC0C1\uD488\uC744 \uCD94\uAC00\uD560 \uC218 \uC5C6\uC2B5\uB2C8\uB2E4.")
              });
            }
            if (existIds.length > 0) {
              setError('itemIds', {
                message: "".concat(existIds === null || existIds === void 0 ? void 0 : existIds.join(', '), " \uC0C1\uD488\uC774 \uC774\uBBF8 \uC874\uC7AC\uD569\uB2C8\uB2E4.")
              });
            }
            if (existIds.length === 0 && failedIds.length === 0) {
              onAddItems(storeItems);
              closeModal();
              if (deduplicatedIds.length !== formattedIds.length) {
                open({
                  content: '중복으로 추가된 상품이 있어, 중복된 상품은 삭제하였습니다.'
                });
              }
            }
          case 19:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function handleClickAdd() {
      return _ref2.apply(this, arguments);
    };
  }();
  return jsx(React__default.Fragment, null, jsx(Button, {
    onClick: function onClick() {
      return setShowModal(true);
    }
  }, "\uC0C1\uD488 \uCD94\uAC00"), showModal && jsx(Modal, {
    isOpen: true,
    size: 500,
    title: "\uC0C1\uD488 \uCD94\uAC00",
    onClose: closeModal,
    primary: {
      text: '확인',
      handler: handleSubmit(handleClickAdd),
      disabled: errorMessage != null
    },
    secondary: {
      text: '취소',
      handler: closeModal
    }
  }, jsx(FormProvider, form, jsx("p", null, "\uCD94\uAC00\uD558\uC2E4 \uC0C1\uD488\uB4E4\uC758 id\uB97C \uC785\uB825\uD574\uC8FC\uC138\uC694."), jsx(ItemInput, {
    name: "itemIds",
    size: 32,
    width: "100%",
    placeholder: "\uC5EC\uB7EC\uAC1C\uB97C \uC870\uD68C\uD560 \uACBD\uC6B0 \uC27C\uD45C\uB098 \uACF5\uBC31\uC73C\uB85C \uAD6C\uBD84\uD574\uC8FC\uC138\uC694.",
    rules: {
      validate: function validate(value) {
        if (!validateStringNumber(value)) {
          return '숫자와 쉼표만 입력할 수 있습니다.';
        }
        return true;
      }
    }
  }))));
}
var ItemInput = /*#__PURE__*/_styled(TextInputField, process.env.NODE_ENV === "production" ? {
  target: "ejh8dsd0"
} : {
  target: "ejh8dsd0",
  label: "ItemInput"
})(process.env.NODE_ENV === "production" ? {
  name: "1k6141t",
  styles: "margin:16px 0"
} : {
  name: "1k6141t",
  styles: "margin:16px 0",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
});

export { ItemAddModal };
//# sourceMappingURL=ItemAddModal.js.map
